import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./styles/theme.css";

import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PrivateRoute from "./components/PrivateRoute";

import Dashboard from "./pages/Dashboard";
import Banners from "./pages/Banners";
import Noticias from "./pages/Noticias";
import Login from "./pages/Login";
import Institucional from "./pages/Institucional";
import Governanca from "./pages/Governanca";
import Transparencia from "./pages/Transparencia";
import ControlesInternos from "./pages/ControlesInternos";
import EducacaoPrevidenciaria from "./pages/EducacaoPrevidenciaria";

// 1. IMPORTANDO AS NOVAS PÁGINAS
import AcessoRapido from "./pages/AcessoRapido"; 
import Faq from "./pages/Faq"; 

function Layout({ children }) {
  return (
    <div style={{ 
      display: "flex", 
      height: "100vh",
      width: "100%",  
      overflow: "hidden" 
    }}>
      <Sidebar />
      <div style={{ 
        flex: 1, 
        display: "flex", 
        flexDirection: "column",
        width: "100%", 
        overflow: "hidden"
      }}>
        <Navbar />
        <div style={{ 
          flex: 1, 
          overflowY: "auto", 
          backgroundColor: "var(--color-bg)" 
        }}>
          {children}
        </div>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* LOGIN (rota pública) */}
        <Route path="/login" element={<Login />} />

        {/* ROTAS PROTEGIDAS */}
        <Route path="/" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
        <Route path="/banners" element={<PrivateRoute><Layout><Banners /></Layout></PrivateRoute>} />
        <Route path="/noticias" element={<PrivateRoute><Layout><Noticias /></Layout></PrivateRoute>} />
        <Route path="/institucional" element={<PrivateRoute><Layout><Institucional /></Layout></PrivateRoute>} />
        <Route path="/governanca" element={<PrivateRoute><Layout><Governanca /></Layout></PrivateRoute>} />
        <Route path="/transparencia" element={<PrivateRoute><Layout><Transparencia /></Layout></PrivateRoute>} />
        <Route path="/controles" element={<PrivateRoute><Layout><ControlesInternos /></Layout></PrivateRoute>} />
        <Route path="/educacao" element={<PrivateRoute><Layout><EducacaoPrevidenciaria /></Layout></PrivateRoute>} />
        
        {/* 2. ADICIONANDO AS NOVAS ROTAS AQUI */}
        <Route path="/acesso-rapido" element={<PrivateRoute><Layout><AcessoRapido /></Layout></PrivateRoute>} />
        <Route path="/faq" element={<PrivateRoute><Layout><Faq /></Layout></PrivateRoute>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;